import { render, staticRenderFns } from "./SiscargaFilterBar.vue?vue&type=template&id=2a55d1a3"
import script from "./SiscargaFilterBar.vue?vue&type=script&lang=js"
export * from "./SiscargaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports